import React from 'react';

import { MdKeyboardArrowDown } from "react-icons/md"


import {
  SelectContainer
} from './styles';

import { ISelectProps } from '../../@interfaces';
import Text from '../text';


const Select: React.FC<ISelectProps> = (props) => {

  return (
    <>
      <SelectContainer
        GAPVertical={props.GAPVertical}
        onClick={props.onOpenOptions}

        noBackgroundColor={props.noBackgroundColor}
        noBorder={props.noBorder}
        backgroundColor={props.backgroundColor}
      >
        <Text className='!text-[.875rem] mr-[15px] !text-[rgb(118,118,118)]'>{props.label}</Text>
        <MdKeyboardArrowDown />
      </SelectContainer>
    </>
  )
}

export default Select;